<template>
  <div v-if="model != null" style="padding-bottom: 10vh;" class="vue_body_min_height">
    <!--  顶部轮播图  -->
    <div class="container-fluid" style="padding-left: 0;padding-right: 0;" v-if="currentBanner != null && currentBanner.length > 0">


      <el-carousel id="home_page_carousel" :height="carouselHeight" :interval="5000">
        <el-carousel-item v-for="(item ,index) in currentBanner" :key="'home_page_banner_' + index" style="background-color: #eee;">
          <div style="text-align: center;width: 100%;position: relative;display: block;">
            <a :target="isHrefLiveVideo(item.redirect) ?  '_self' : '_blank' "
               v-on:click="isHrefLiveVideo(item.redirect) ? liveVideoCoverClicked(item.redirect) : null"
               :href="isHrefLiveVideo(item.redirect) ? 'javascript:void(null);' : item.redirect">
              <img id="banner_first_img"  style="max-width: 100%;" v-if="index == 0" :src="item.url" :alt="item.title" v-on:load="canvasImageLoad">
              <img v-else :src="item.url" style="max-width: 100%;" :alt="item.title" >
              <div v-if="item.title" style="position: absolute;bottom: 0;left: 0;width: 100%;padding-top: 15px;padding-bottom: 25px;background-color: rgba(0,0,0,0.2);z-index: 999;text-align: center;color: white;font-weight: bold;font-size: 1.5rem;">{{item.title}}</div>
            </a>


<!--            <a target="_blank" :href="item.redirect">-->
<!--              <img id="banner_first_img"  style="max-width: 100%;" v-if="index == 0" :src="item.url" v-on:load="canvasImageLoad">-->
<!--              <img v-else :src="item.url" style="max-width: 100%;" >-->
<!--            </a>-->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

<!--   官方消息 -->
    <div id="home_page_official_news" class="container-fluid">
      <div class="home_part_title"><a href="/news">官方消息</a></div>
      <div class="home_part_destitle">OFFICIAL NEWS</div>

      <div class="row">
        <div class="col-xs-12 col-sm-6 home_news_card_outer">
          <div>
            <a v-for="(item, index) in leftNewsList"
               :href="newsSrc(item)"
               target="_blank"
               @click="newsItemClicked(item)"
               :key="'home_page_left_news_' + index">
<!--              <div>{{item.actionTitle}}</div>-->
              <hot-label :title="item.actionTitle" :flag="item.flag" :flagInvalidTIme="item.flagInvalidTime"></hot-label>
              <div>{{newsDate(item.createTime)}}</div>
            </a>
          </div>
        </div>
        <div v-if="screenSmall == false" class="col-xs-12 col-sm-6 home_news_card_outer">
          <div>
            <a v-for="(item, index) in rightNewsList"
               :href="newsSrc(item)"
               target="_blank"
               :key="'home_page_right_news_' + index">
<!--              <div>{{item.actionTitle}}</div>-->
              <hot-label :title="item.actionTitle" :flag="item.flag" :flagInvalidTIme="item.flagInvalidTIme"></hot-label>
              <div>{{newsDate(item.createTime)}}</div>
            </a>
          </div>
        </div>
      </div>

<!--      <div id="home_news_more_btn">-->
<!--        <a href="/news">查看更多</a>-->
<!--      </div>-->

    </div>


    <!--    最新动态-->
    <div id="home_page_current_affairs" class="container-fluid">
      <div class="home_part_title"><a href="/news/0302">最新动态</a></div>
      <div class="home_part_destitle">WHAT'S NEW</div>
      <div class="row" id="home_page_affairs_list_outer">
        <div class="col-xs-12 col-sm-4" v-for="(item, index) in activityList" :key="'home_page_news_' + index" style="margin-top: 15px;">
          <home-affair-card :item="item"></home-affair-card>
        </div>
      </div>

      <!--      <div id="home_paeg_affairs_more_btn">-->
      <!--        <a href="/news/0302">查看更多</a>-->
      <!--      </div>-->
    </div>

<!--篮球赛事-->
    <div id="home_page_scheule_center">
      <div class="home_part_title"><a href="/matches">篮球赛事</a></div>
      <div class="home_part_destitle">BASKETBALL MATCH</div>
      <div class="container">
        <div id="matches_list_outer" v-if="matches != null">
          <home-match-card v-for="(item, index) in matches" :key="'home_match_item_' + index" :item="item" />
        </div>
      </div>

<!--      <div id="home_page_schdule_cards" :class="[scheduleCardsClass]">-->
<!--        <home-schedule-card-->
<!--          v-for="(item, index) in matchRecords"-->
<!--          :key="'match_schedule_card_' + index" />-->

<!--      </div>-->
      <div style="clear: both;"></div>
    </div>

<!--    课程中心-->
    <div id="home_page_curriculum_center" class="container-fluid">
      <div class="home_part_title"><a href="/training">课程中心</a></div>
      <div class="home_part_destitle">CURRICULUM CENTER</div>

      <div id="home_page_curri_list_outer" class="row">
        <div  class="container" style="display: flex;flex-direction: row;justify-content: center;flex-wrap: wrap;">
          <HomeCurriculumCard v-for="(item, index) in trainings" :key="'home_page_curri_' + index" :item="item" />
        </div>
      </div>

<!--      <div id="home_curriculum_more_btn">-->
<!--        <a href="/training">查看更多</a>-->
<!--      </div>-->
    </div>


<!--  精彩视频  -->
    <div id="home_page_hot_videos" class="container-fluid" style="padding-left: 0;padding-right: 0;">
      <div class="home_part_title"><a href="/news/0303">精彩视频</a></div>
      <div class="home_part_destitle">WONDERFUL VIDEO</div>
      <div id="home_page_video_outer">
        <videos-carousel :video-list="videoList"
                         v-on:video-changed="carouselChanged"
                         v-on:playVideo="playVideoClick"></videos-carousel>

        <div style="color: #333;font-size: 1.2rem;padding-top: 15px;padding-left: 5px;padding-right: 5px;text-align: center;height: 100px;">{{videoList[videoIndex].title}}</div>
      </div>
<!--      <div id="home_page_video_outer">-->
<!--        <HomeVideoPlay :item="currenVideoItem" @next-clicked="nextVideoClicked" />-->
<!--      </div>-->
    </div>

    <div  v-if="pictureList != null" class="container-fluid" style="margin-top: 30px;">
      <div class="home_part_title"><a href="/news/0304">精彩图片</a></div>
      <div class="home_part_destitle">WONDERFUL PICTURE</div>
      <div class="row" id="home_page_picture_list_outer">
        <a style="display: block;text-align: center;margin-top: 15px;text-decoration: none;"
           class="col-xs-12 col-sm-4"
           target="_blank"
           v-for="(item, index) in pictureList"
           :href="pictureItemSrc(item)"
           :key="'home_picture_list_' + index" >
          <img class="img-responsive" :src="posterImg(item)">
          <div style="margin-top: 15px;color: #333;">{{item.actionTitle}}</div>
        </a>
      </div>
    </div>



<!--    友情链接-->
    <div id="home_page_company_links" class="container-fluid">
      <div class="home_part_title">友情链接</div>
      <div class="home_part_destitle">LINKS</div>

      <div class="row" id="home_page_links_outer">
        <div v-for="(item, index) in model.friendlyLinks" :key="'home_page_link_' + index">

          <div v-if="item.mediaUrl != null && item.mediaUrl.length > 0 && item.mediaUrl != 'https://img.shslqxh.com/blank.gif'" style="position: relative">
            <a href="javascript:void(null);">
              <img :src="item.url" @click="qrCodeLinkImgClicked(index)">
            </a>
            <div v-if="qrCodeIndex == index">
              <div style="position:fixed;left: 0;top: 0;background-color: transparent;width: 100vw;height: 100vh;z-index: 998;" @click="qrCodeImgHide">
              </div>
              <div class="img-2-qr">
                <img :src="item.mediaUrl" style="height: auto;width: 100%;text-align: center;">
              </div>
            </div>
          </div>

          <a v-else-if="item.redirect == null || item.redirect.length == 0 " href="javascript:void(0);" >
            <img :src="item.url">
          </a>

          <a v-else :href="item.redirect" target="_blank">
            <img :src="item.url">
          </a>
        </div>

      </div>
    </div>

    <div id="live_video_play" v-if="showLiveVideo">
      <video id="my_live_video" controls preload="auto" class="video-js vjs-default-skin" :width="videoWidth" height="auto"
             >
        <source :src="liveVideoSrc" >
        您的浏览器不支持 HTML5 video 标签。
      </video>

      <a class="iconfont"
         href="javascript:void(null);"
         @click="closeLiveVideo"
         style="position: absolute;top: 50px;right: 50px;color: white;font-size: 2rem;z-index: 999;text-decoration: none;">&#xe639;</a>
    </div>
  </div>
</template>

<script>
import HomeScheduleCard from "../components/HomeScheduleCard";
import HomeCurriculumCard from "../components/HomeCurriculumCard";
import HomeAffairCard from "../components/HomeAffairCard";
import HomeVideoPlay from "../components/HomeVideoPlay";
import HomeMatchCard from "../components/matches/HomeMatchCard";
import HotLabel from "../components/common/HotLabel";
import VideosCarousel from "../components/common/VideosCarousel";
import 'video.js'

export default {
  name: "HomePage",
  components: {
    HomeVideoPlay,
    HomeAffairCard,
    HomeCurriculumCard,
    HomeScheduleCard,
    HomeMatchCard,
    HotLabel,
    VideosCarousel
  },
  data() {
    return {
      curriculumCenterValue: false,
      model: null,
      videoIndex: 0,
      screenSmall: false,
      carouselHeight: '300px',
      imageLoaded: false,
      firstImageWidth: 0,
      firstImageHeight: 0,
      qrCodeIndex: -1,
      showLiveVideo: false,
      liveVideoSrc: null,
      videoWidth: 960,
      videoPlayer: null,
      pictureList: null,
      videoIndex: 0,
    }
  },
  computed: {
    scheduleCardsClass() {
      return this.curriculumCenterValue ? 'home-card-schedule-cards-center' : 'home-card-schedule-cards-space-between';
    },

    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }

      let homeBanners = [];
      for (let i = 0; i < this.banners.length; i++) {
        let item = this.banners[i];
        if (item.name == 'hp') {
          homeBanners.push(item);
        }
      }
      return homeBanners;
    },

    leftNewsList() {
      let tempList = [];
      let newsList = this.model.officals;
      if (newsList == null) {
        return tempList;
      }

      if (newsList.length <= 6) {
        return newsList;
      }
      tempList = newsList.slice(0, 6);
      return tempList;
    },
    rightNewsList() {
      let tempList = [];
      let newsList = this.model.officals;
      if (newsList == null || newsList.length <= 6) {
        return tempList;
      }
      tempList = newsList.slice(6, newsList.length)
      return tempList;
    },
    matchRecords() {
      return this.model.matchRecords;
    },
    matches () {
     return this.model.matches;
    },
    trainings() {
      return this.model.trainings;
    },
    activityList() {
      return this.model.activities;
    },
    videoList() {
      return this.model.videos;
    },
    currenVideoItem() {
      let videos = this.videoList;
      if (videos != null && videos.length > this.videoIndex) {
        return videos[this.videoIndex];
      }
      return null;
    }
  },
  mounted() {
    $(window).resize(this.updateStatus);
    setTimeout(this.updateStatus, 500);
    this.loadData();
    this.configShareWx(encodeURIComponent(location.href), this.$store.state.http.defaultShareObj);
    this.loadPictureData();
  },
  methods: {

    carouselChanged(res) {
      this.videoIndex = res.index;
    },
    pictureItemSrc(item) {
      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/news/0304/0/' + item.id;
    },

    posterImg(item) {
      let imageUrls = item.imageUrls;
      if (imageUrls != null && imageUrls.length > 0) {
        let pic = imageUrls.split('?')[0];
        return pic
      }
      return '';
    },

    loadPictureData() {
      if (this.isLoading) {
        return;
      }
      let params = {
        pageIndex: 1,
        size: 3,
        type: 3,
        tag: '全部',
      };
      let _this = this;
      this.$store.state.http.ajax.vmActivities(params,function (data) {
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          _this.pictureList = newList;
          return;
        }
      },function (data) {
      });
    },

    qrCodeLinkImgClicked(index) {
      this.qrCodeIndex = index;
    },

    qrCodeImgHide() {
      this.qrCodeIndex = -1;
    },

    canvasImageLoad() {
      this.imageLoaded = true;
      let image = document.getElementById('banner_first_img');
      let imgWidth = image.width;
      let imgHeight = image.height;
      this.firstImageWidth = imgWidth;
      this.firstImageHeight = imgHeight;
      this.calculateImageHeight();
    },
    calculateImageHeight() {
      if (!this.imageLoaded) {
        return;
      }
      let imgWidth = this.firstImageWidth;
      let imgHeight = this.firstImageHeight;
      if (imgWidth == 0) {
        return;
      }

      let carouselWidth = $("#home_page_carousel").width();
      let exactHeight = 0;
      if (imgWidth <= carouselWidth) {
        exactHeight = imgHeight;
      } else {

        exactHeight = Math.round(carouselWidth / imgWidth * imgHeight);
      }
      this.carouselHeight = exactHeight + 'px';
    },

    updateStatus() {
      let width = $('#home_page_schdule_cards').width();
      if (width >= 630) {
        this.curriculumCenterValue = false;
      } else {
        this.curriculumCenterValue = true;
      }

      let _this = this;

      let newsWidth = $('#home_page_official_news').width();
      if (newsWidth >= 768) {
        this.screenSmall = false
      } else  {
        this.screenSmall = true
      }
      this.calculateImageHeight();

      let screenWidth = document.body.clientWidth;
      let tmp = Math.round(screenWidth * 0.8) + '';
      _this.videoWidth = parseInt(tmp);

    },
    loadData() {
      let _this = this;
      this.$store.state.http.ajax.vmHp(function (data) {
        // console.log(data);
        if (data.code == 0) {
          _this.model = data.data;
        }
      }, function (data) {
        _this.$toast('请求失败，请重试！');
      })
    },

    newsDate(date) {
      return this.$moment(date).format('yyyy.MM.DD');
    },
    newsSrc(item) {
      let web = item.newsUrl;
      if (web != undefined && web != null && web != '') {
        return web;
      }


      return '/news/0301/0/' + item.id;
    },
    nextVideoClicked() {
      let index = this.videoIndex;
      index ++;
      let count = (this.videoList == null) ? 0 : this.videoList.length;
      if (index >= count) {
        index = 0;
      }
      this.videoIndex = index;
    },
    isHrefLiveVideo(src) {
      if (src == undefined || src == null || src == '') {
        return false;
      }
      let patt = /\.m3u8$/;
      return patt.test(src);
    },
    liveVideoCoverClicked(src) {
      this.liveVideoSrc = src;
      this.showLiveVideo = true;
      let _this = this;
      setTimeout(function () {
        var player = videojs('my_live_video', {}, function () {
          player.play();
          _this.videoPlayer = player;
        })
      },400);
    },
    closeLiveVideo() {
      this.videoPlayer.pause();
      this.videoPlayer.dispose();
      this.videoPlayer = null;
      this.showLiveVideo = false;
      this.liveVideoSrc = null;
    },
    playVideoClick(res) {
      let url = res.url;
      this.liveVideoCoverClicked(url);
    }
  }
}
</script>

<style scoped>
  #top_picture_carousel {
    /*width: 100%;*/
    /*height: 51.5844vw;*/
    /*max-height: 400px;*/
  }

  .carsousel_image_div {
    width: 100vw;
    /*height: 51.5844vw;*/
    /*max-height:400px;*/
    background-color: #111;
    text-align: center;
  }
  .carsousel_image_div img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: 100%;
    display: block;
    /*margin: 0 auto;*/
    margin: auto;
  }


  .home_part_title {
    font-size: 2rem;
    color: #333;
    letter-spacing: 3px;
    background-image: url("../assets/shl_home_horizon_seprator_1.png");
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 70px 2px;
    padding: 10px;
    padding-bottom: 8px;
    text-align: center;
  }

  .home_part_title a {
    text-decoration: none;
    color: inherit;
  }

  .home_part_title a:hover {
    color: #fc1a34;
  }


  .home_part_destitle {
    font-size: 0.6rem;
    letter-spacing: 1.5px;
    text-align: center;
    margin-top: 10px;
  }

  #home_page_official_news {
    background-image: url("../assets/shl_home_official_bg.png");
    background-position: center top;
    background-size: auto 100%;
    margin-top: 4vw;
    padding-top: 20px;
    padding-bottom: 60px;
    background-repeat: no-repeat;
    -ms-interpolation-mode: bicubic;
  }

  @media (min-width: 750px) {
    #home_page_official_news {
      background-size: auto 100%;
    }
  }

  @media (max-width: 749px) {
    #home_page_official_news {
      background-size: auto 100%;
    }
  }

  .home_news_card_outer {
    padding: 20px 5px;
  }

  .home_news_card_outer > div {
    width: 100%;
    padding: 20px 10px;
    min-height: 200px;
    border-radius: 8px;
    border: solid 1px transparent;
    background-color: rgba(255, 255, 255, 0.7);
    box-shadow: 0 0 4px rgba(120,120,120,0.3);
  }

  @media screen and (min-width: 768px){
    .home_news_card_outer {
      padding: 20px 4vw;
    }

    .home_news_card_outer > div {
      padding: 30px;
    }
  }

  .home_news_card_outer a {
    width: 100%;
    display: inline-flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    text-decoration: none;
    font-size: 15px;
  }

  .home_news_card_outer a:not(:first-child) {
    margin-top: 6px;
  }

  .home_news_card_outer a > div:first-child {
    color: #333;
  }

  .home_news_card_outer a > div:last-child {
    color: #aaa;
    /*min-width: 13rem;*/
    text-align: right;
    margin-left: 5px;
  }

  .home_news_card_outer a:hover > div:first-child {
    color: #000;
  }

  .home_news_card_outer a:hover > div:last-child {
    color: #777;
  }

  #home_news_more_btn, #home_paeg_affairs_more_btn {
    text-align: center;
  }

  #home_news_more_btn > a, #home_paeg_affairs_more_btn > a {
    color: black;
    font-weight: bold;
    font-size: 1.5rem;
    text-decoration: none;
  }
  #home_news_more_btn > a:hover, #home_paeg_affairs_more_btn > a:hover {
    color: #333;
  }

  #home_page_scheule_center {
    padding-top: 0px;
    padding-bottom: 30px;
    background-image: url("../assets/shl_home_schedule_center_bg.png");
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center center;
    -ms-interpolation-mode: bicubic;
    position: relative;
    min-height: 575px;
  }

  @media (min-width: 768px) {
    #home_page_scheule_center {
      /*height: 575px;*/
    }
  }
  @media (max-width: 767px) {
    #home_page_scheule_center {
      /*min-height: 575px;*/
    }
  }

  .home-card-schedule-cards-center {
    margin-top: 45px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    width: 90%;
    min-width: 290px;
    max-width: 630px;
    float: right;
  }

  .home-card-schedule-cards-space-between {
    margin-top: 45px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    min-width: 290px;
    max-width: 630px;
    float: right;
    margin-right: 15px;
  }

  @media screen and (min-width: 768px) {
    .home-card-schedule-cards-space-between {
      margin-right: 10%;
    }
  }


  #home_page_curriculum_center {
    padding-top: 30px;
    background-image: url("../assets/shl_home_curriculum_center_bg.png");
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center top;
    padding-bottom: 50px;
    -ms-interpolation-mode: bicubic;
    min-height: 520px;
  }


  @media screen and (max-width:1099px){
    #home_page_curriculum_center {
      height: auto;
      /*min-height: 575px;*/
    }
  }

  #home_page_curriculum_center .home_part_title, #home_page_curriculum_center .home_part_destitle {
    color: white;
  }

  #home_page_curriculum_center .home_part_title a:hover {
    color: #eee;
  }

  #home_page_curriculum_center .home_part_title {
    background-image: url("../assets/shl_home_horizon_seprator_2.png");
  }

  #home_page_curri_list_outer {
    margin-top: 50px;
  }

  #home_curriculum_more_btn {
    text-align: center;
    margin-top: 50px;
  }
  #home_curriculum_more_btn > a {
    color: white;
    text-decoration: none;
    font-weight: bold;
    font-size: 1.5rem;
  }

  #home_curriculum_more_btn > a:hover {
    color: #eee;
   }

  #home_page_current_affairs {
    margin-top: 4vh;
    padding-bottom: 30px;
  }

  #home_page_affairs_list_outer {
    margin-top: 30px;
    padding-bottom: 30px;
    padding-left: 5px;
    padding-right: 5px;
  }

  #home_page_affairs_list_outer > div {
    padding: 0;
  }


  @media screen and (min-width: 768px) {
    #home_page_affairs_list_outer {
      margin-top: 30px;
      padding-bottom: 30px;
      padding-left: 4vw;
      padding-right: 4vw;
    }

    #home_page_affairs_list_outer > div {
      padding: 0 5px;
    }
  }

  #home_page_hot_videos {
    /*margin-top: 30px;*/
    padding-top: 30px;
    background-image: url("../assets/shl_home_page_videos_bg.png");
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center bottom;
    -ms-interpolation-mode: bicubic;
  }

  #home_page_video_outer {

    /*padding-left: 10vw;*/
    /*padding-right: 10vw;*/
    /*padding-top: 0px;*/
    margin-top: 80px;
  }

  @media screen and (min-width: 768px){
    #home_page_video_outer {
      /*padding-left: 60px;*/
      /*padding-right: 60px;*/
    }
  }
  @media screen and (max-width: 767px) {
    #home_page_video_outer {
      /*padding-left: 30px;*/
      /*padding-right: 30px;*/
    }
  }

  @media screen and (max-width: 450px) {
    #home_page_video_outer {
      /*padding-left: 15px;*/
      /*padding-right: 15px;*/
    }
  }

  #home_page_company_links {
    margin-top: 10vh;
  }


  #home_page_links_outer {
    margin-top: 4vh;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  #home_page_links_outer > div {
    padding: 0 30px;
    padding-top: 15px;
  }

  #home_page_links_outer img {
    width: auto;
    max-width: 150px;
    height: auto;
    -ms-interpolation-mode: bicubic;
  }

  #home_page_links_outer .img-2-qr {
    width: 200px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    transform: translateX(0) translateY(-110%);
  }

  #matches_list_outer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
    margin-top: 30px;
    padding-bottom: 30px;
  }

  @media screen and (min-width: 768px){
    #matches_list_outer {
      justify-content: space-around;

    }
  }

  #live_video_play {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
  }

  #live_video_play video {
    /*width: 80%;*/
    /*min-height: 60%;*/
  }



  #home_page_picture_list_outer {
    margin-top: 40px;
    padding-bottom: 30px;
    padding-left: 5px;
    padding-right: 5px;
  }

  #home_page_picture_list_outer > div {
    padding: 0;
  }


  @media screen and (min-width: 768px) {
    #home_page_picture_list_outer {
      margin-top: 40px;
      padding-bottom: 30px;
      padding-left: 4vw;
      padding-right: 4vw;
    }

    #home_page_picture_list_outer > div {
      padding: 0 5px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue